module.exports = __webpack_public_path__ + "static/media/arrowUp.8f7ad915.svg";